import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Container,
  Drawer,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppColors } from "../../../../util/AppColors";

// Import Thunks
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTable from "../../../../components/CustomTable";
import CustomTextField from "../../../../components/CustomTextField";
import TopBar from "../../../../components/TopBar/TopBar";
import {
  createOperationTheatre,
  deleteOperationTheatre,
  getOperationTheatreList,
  updateOperationTheatre,
} from "../../../../redux/reducers/operationTheatreSlice";

const tblHdrs = [
  "sNo",
  "operationTheatre",
  "newStatus",
  "createdBy",
  "createdDate",
  "actions",
];

function OperationTheatre() {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ OperationTheatre: "" });
  const [editForm, setEditForm] = useState({ OperationTheatre: "" });

  const operationTheatreState = useSelector((state) => state.operationTheatre);
  const operationTheatreList = operationTheatreState.list;
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  useEffect(() => {
    dispatch(getOperationTheatreList());
  }, [dispatch]);

  const handleAddOrUpdate = () => {
    if (!form.OperationTheatre.trim()) return;

    if (editIndex !== null) {
      const theatre = operationTheatreList[editIndex];
      dispatch(
        updateOperationTheatre({
          facilityId: theatre.facilityId,
          name: form.OperationTheatre,
        })
      );
    } else {
      dispatch(createOperationTheatre({ name: form.OperationTheatre }));
    }

    handleCloseDrawer();
  };

  const handleEdit = (index) => {
    const theatre = operationTheatreList[index];
    setForm({ OperationTheatre: theatre.name });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  // const handleDelete = (index) => {
  //   const theatre = operationTheatreList[index];
  //   dispatch(deleteOperationTheatre({ facilityId: theatre.facilityId }));
  // };
  const handleDelete = (index) => {
    setDeleteIndex(index);
    setDelModVisible(true);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteIndex(null);
  };

  const handleDelConfirm = () => {
    const facilityId = operationTheatreList[deleteIndex]?.facilityId;
    if (facilityId) {
      dispatch(deleteOperationTheatre({ facilityId }));
    }
    handleDelModClose();
  };
  const handleUpdate = () => {
    if (!editForm.OperationTheatre.trim()) return;

    const theatre = operationTheatreList[editIndex];
    dispatch(
      updateOperationTheatre({
        facilityId: theatre.facilityId,
        name: editForm.OperationTheatre,
      })
    ).then(() => {
      handleCloseEditDialog();
    });
  };
  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setForm({ OperationTheatre: "" });
    setEditIndex(null);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setEditIndex(null);
    setEditForm({ OperationTheatre: "" });
  };

  const filteredRows = operationTheatreList.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleChangeSwitch = (status, theatre) => {
    dispatch(
      updateOperationTheatre({
        facilityId: theatre?.facilityId,
        name: theatre?.name,
        status,
      })
    ).then((res) => {
      if (res?.payload) dispatch(getOperationTheatreList());
    });
  };

  return (
    <Box>
      {/* Top section */}
      <TopBar>
        <Container maxWidth="xl">
          <Toolbar variant="regular">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div className="top-row-cen-con w100Per">
                  <div className="w30Per">
                    <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearch(e.target.value)}
                      value={search}
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>

                  <div className="ml20">
                    <CustomButton
                      text="Create"
                      onClick={() => setOpenDrawer(true)}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Toolbar>
          <Typography className="font-medium fs12 gray28">
            Total Theatres: {filteredRows?.length}
          </Typography>
        </Container>
      </TopBar>

      {/* Table */}
      <CustomTable
        grey
        columns={tblHdrs}
        datas={filteredRows?.map((theatre, index) => ({
          sNo: index + 1,
          operationTheatre: theatre?.name,
          newStatus: (
            <div>
              <div>
                <CustomSwitch
                  value={theatre?.status}
                  onChange={(e) =>
                    handleChangeSwitch(e?.target?.value, theatre)
                  }
                  greenToRed
                />
              </div>
              <div>{theatre?.status ? "Active" : "Under Maintenance"}</div>
            </div>
          ),
          createdBy: theatre?.userName || "-",
          createdDate: new Date(theatre?.createdDate).toLocaleDateString(),
          actions: (
            <div>
              <IconButton
                color="primary"
                size="small"
                onClick={() => handleEdit(index)}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                color="error"
                size="small"
                onClick={() => handleDelete(index)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        }))}
      />

      {/* Drawer */}
      <Drawer anchor="right" open={openDrawer} onClose={handleCloseDrawer}>
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Theatre" : "Create Theatre"}
            </Typography>
            <IconButton onClick={handleCloseDrawer} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Operation Theatre Name"
            value={form.OperationTheatre}
            onChange={(e) =>
              setForm({ ...form, OperationTheatre: e.target.value })
            }
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      {/* Edit Dialog */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default OperationTheatre;
